import { render } from "./device-check.vue?vue&type=template&id=615f7b72&scoped=true"
import script from "./device-check.vue?vue&type=script&lang=js"
export * from "./device-check.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-615f7b72"

export default script